<template>
  <div>
    <v-data-table
      v-show="items.length > 0"
      :dense="dense"
      :show-select="showSelect"
      :single-select="singleSelect"
      :hide-default-footer="hideDefaultFooter"
      :must-sort="mustSort"
      :sort-by="sortBy"
      :search="search"
      :headers="headers"
      :items="items"
      :value="value"
      @input="evOnInput"
      :footer-props="footerProps"
    >
      <slot v-for="(_, name) in $slots" :name="name" :slot="name" />
      <template
        v-for="(_, name) in $scopedSlots"
        :slot="name"
        slot-scope="slotData"
      >
        <slot :name="name" v-bind="slotData" />
      </template>
    </v-data-table>
    <div v-show="showNoData && items.length === 0" class="col-12 v-clean p-5">
      <h6 class="text-center upper-text worksansr">
        {{ noDataText }}
      </h6>
    </div>
  </div>
</template>

<script>
export default {
  name: "VDataTableDefault",

  props: {
    dense: { type: Boolean, default: true },
    mustSort: { type: Boolean, default: false },
    sortBy: { type: String, default: "" },
    headers: { type: Array, required: true },
    items: { type: Array, required: true },
    search: { type: String, default: "" },
    showSelect: { type: Boolean, default: false },
    singleSelect: { type: Boolean, default: false },
    hideDefaultFooter: { type: Boolean, default: false },
    noDataText: { Type: String, default: "Nenhuma informação adicionada." },
    value: { type: Array, required: false },
    footerProps: { type: Object, required: false },
    showNoData: { type: Boolean, required: false, default: true },
  },

  methods: {
    evOnInput(value) {
      this.$emit("input", value);
    },
  },
};
</script>

<style>
</style>